export interface IValuationHistory {
    adUrls?: IAdUrlViewModel[];
    appraisalApprovalStatus: string;
    appraisalApprovalStatusEnum: AppraisalReportApprovalStatus;
    appraisalStartPage: number;
    appraisalStatus: string;
    appraisalStatusEnum: AppraisalStatus;
    commonDebt: number;
    date: Date;
    dateDescription: string;
    detailId: number;
    documentPath: string;
    externalUsableArea: number;
    glazedBalconyUsableArea: number;
    grossArea: number;
    hasAdText: boolean;
    infoTextJSON: string;
    internalUsableArea: number;
    isLatestAndAppraisal: boolean;
    livingArea: number;
    lowHeightFloorArea: number;
    measuredPrimaryArea: number;
    openTerraceAndBalconyArea: number;
    priceAssumption: IPriceAssumptions;
    priceAssumptionValue: number;
    priceAssumptionsJSON: string;
    prioritizedValue: number;
    refId: string;
    reportId: number;
    residentialMeasuredArea: number;
    residentialMeasuredAreaAreaType: string;
    sortDate: Date;
    squareMeterPrice: number;
    totalValue: number;
    usableArea: number;
    value: number;
    valueHistoryType: string;
    valueHistoryTypeEnum: ValueHistoryType;
    whiteLabel: string;
}

export interface IAdUrlViewModel {
    source: AdType;
    url: string;
}

export enum AdType {
    Finn = 0,
    Hjem = 1,
}

export enum AppraisalReportApprovalStatus {
    Processing = 1,
    Approved = 2,
    Rejected = 3,
    Undefined = 4,
}

export enum AppraisalStatus {
    Created = 1,
    Activated = 2,
    ActivatedAndSent = 3,
}

export interface IPriceAssumptions {
    PriceAssumptionHistory: IPriceAssumption[];
}

export interface IPriceAssumption {
    Date: string;
    PriceAssumption: number;
    ChangePrev: number;
    ChangeInitial: number;
}

export enum ValueHistoryType {
    All = 0,
    Meglersalg = 1,
    Tinglysning = 2,
    ETakst = 3,
    Takst = 4,
    LagretEstimat = 5,
    ETakstMegler = 6,
    TakenShare = 7,
    CommercialAppraisalAgent = 8,
    CommercialAppraisalBank = 9,
    CommercialSale = 10,
    PreAppraisalBank = 11,
    PreAppraisalAgent = 12
}

export enum ValueHistoryFilterType {
    MarketSales = 1,
    ETakstAndTakst = 2,
    Registered = 3,
    SavedEstimate = 4,
}